import React from 'react'

import { InsightsMicroWidgetDataContext } from './InsightsMicroWidgetDataProvider'

export const useDataContext = () => {
  const context = React.useContext(InsightsMicroWidgetDataContext)

  if (!context) {
    throw new Error('useDataContext() must be used within the InsightsMicroWidgetDataProvider')
  }

  return context
}

export const useStore = () => {
  const context = React.useContext(InsightsMicroWidgetDataContext)

  if (!context) {
    throw new Error('useStore() must be used within the InsightsMicroWidgetDataProvider')
  }

  return context.store
}

export const useCopyStore = () => {
  const context = React.useContext(InsightsMicroWidgetDataContext)

  if (!context) {
    throw new Error('useCopyStore() must be used within the InsightsMicroWidgetDataProvider')
  }

  return context.store.copyStore
}

export const useInsightsMicroWidgetStore = () => {
  const context = React.useContext(InsightsMicroWidgetDataContext)

  if (!context?.store?.insightsMicroWidgetStore) {
    throw new Error(
      'useInsightsMicroWidgetStore() must be used within the InsightsMicroWidgetDataProvider',
    )
  }

  return context.store.insightsMicroWidgetStore
}

export const useEvent = () => {
  const context = React.useContext(InsightsMicroWidgetDataContext)

  if (!context) {
    throw new Error('useEvent() must be used within the InsightsMicroWidgetDataProvider')
  }

  return { onEvent: context.onEvent }
}

export const usePageview = () => {
  const context = React.useContext(InsightsMicroWidgetDataContext)

  if (!context) {
    throw new Error('usePageview() must be used within the InsightsMicroWidgetDataProvider')
  }

  return { onPageview: context.onPageview }
}
